import type { ValueOf } from '#layers/base/public';
import { callOrReturn } from '#layers/base/public';

export const Availability = {
	New: 'new',
	Soon: 'soon',
} as const;

export type Availability = ValueOf<typeof Availability>;
export type ConnectorAvailability = Availability | undefined;
export type ConnectorAvailableSince = string | (() => string | undefined);

export interface ConnectorAvailabilitySource {
	availableSince?: ConnectorAvailableSince;
}

export function resolveConnectorAvailableSince(
	availableSince: ConnectorAvailableSince | undefined,
) {
	return callOrReturn(availableSince);
}

export function connectorAvailability(
	connector: ConnectorAvailabilitySource,
	now: Date = new Date(),
): ConnectorAvailability {
	const availableSince = resolveConnectorAvailableSince(connector.availableSince);

	if (!availableSince) return Availability.Soon;

	const since = new Date(availableSince);
	if (since > now) return Availability.Soon;

	const threeMonthsAgo = new Date(now);
	threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
	// When DST differs between March and June (e.g., CET->CEST),
	// the resulting threeMonthsAgo can be off by an hour.
	threeMonthsAgo.setUTCHours(0, 0, 0, 0);

	if (since >= threeMonthsAgo) return Availability.New;
	return undefined;
}
